/**
 * MediaButton Component
 */

import * as React from 'react';
import * as BEM from 'react-bem-helper';

import Button from '../../../../atoms/buttons/Button';
import { IconInfoFilled } from '../../../../atoms/images/Icon';
import { Tooltip } from '../../../../atoms/text/Tooltip';
import { baseline } from '../../../../styles/grid';

export interface IMediaButtonProps {
  hint?: string;
  icon: JSX.Element;
  id: LicenseMediaTypeIdentifier;
  name: string;
  onClick(component: ILicenseComponent): void;
}

const classes = new BEM('media-button');

export class MediaButton extends React.PureComponent<IMediaButtonProps> {
  onClick = () => {
    const { id, name } = this.props;
    this.props.onClick({ id, name });
  }

  render() {
    return (
      <Button
        onClick={this.onClick}
        icon={this.props.icon}
        label={this.props.name}
        size="medium"
        {...classes()}
      >
        {this.props.hint && (
          <Tooltip
            content={this.props.hint}
            distance={baseline * 4}
            placement="bottom"
            theme="black"
          >
            <IconInfoFilled {...classes('tooltip')} />
          </Tooltip>
        )}
      </Button>
    );
  }
}



// WEBPACK FOOTER //
// ./node_modules/tslint-loader??ref--0!./src/public/components/molecules/forms/license-builder/SelectMedia/MediaButton.tsx